export function toAnalyticsPagePath(url: string): string {
  const pagePath = url.split('#', 1)[0] || '/';

  return pagePath.startsWith('/') ? pagePath : `/${pagePath}`;
}
